module.exports = __webpack_public_path__ + "media/svg-new/icon-question1-eabb31d5.svg";